import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import { useFormik } from "formik"
import _ from "lodash"
import { useParams } from "react-router-dom"
import * as Yup from "yup"
import { getTemplateById, updateTemplate } from "services/exports/calls"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

import Select from "react-select"
import { getRoles } from "services/users/calls"

import DualListBox from "react-dual-listbox"
import "react-dual-listbox/lib/react-dual-listbox.css"
import { getCheckboxes } from "services/orders/tracking/calls"

const UpdateTemplate = props => {
  const { t } = props
  let { id } = useParams()
  let history = useHistory()

  const [activeTab, setactiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])
  const [checkboxes, setCheckboxes] = useState([])
  const [errors, setErrors] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [template, setTemplate] = useState([])
  const [listaPerfis, setListaPerfis] = useState()

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  const sortByColumnName = (a, b) => {
    var textA = a.title.toUpperCase()
    var textB = b.title.toUpperCase()
    return textA < textB ? -1 : textA > textB ? 1 : 0
  }

  const fetchCheckBoxes = async () => {
    const { checkboxes } = await getCheckboxes()
    const uniqueCheckboxes = Array.from(
      new Set(checkboxes.map(a => a.column))
    ).map(column => {
      return checkboxes.find(a => a.column === column)
    })
    setCheckboxes(
      uniqueCheckboxes.sort(sortByColumnName).map((c, i) => ({
        ...c,
        checked: true,
      }))
    )
  }

  const fetchTemplate = async id => {
    try {
      const { payload: roles } = await getRoles()
      setListaPerfis(roles?.roles)
      const { payload: template } = await getTemplateById(id)
      const templateRolesIds = template?.roleId?.split(",")
      const templateWithRoles = {
        ...template,
        role: templateRolesIds?.map(tr => {
          const role = roles?.roles.find(r => r.id == tr)
          if (role) {
            return { label: role.name, value: role.id }
          }
        }),
      }
      setTemplate(templateWithRoles)
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const perfisOptions = listaPerfis?.map(p => ({ label: p.name, value: p.id }))

  useEffect(() => {
    try {
      fetchCheckBoxes()
      fetchTemplate(id)
    } catch (error) {
      console.error(error)
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: template?.templateName,
      tag: template?.alias,
      // checkboxes: template.checkboxes.map(cb => {
      //   cb.name
      // }),
      isNormalized: template?.isNormalized || false,
      // checkboxes: JSON.parse(template?.filters || "{}")?.filters || [],
      checkBoxesDuallist: JSON.parse(template?.filters || "{}")?.filters || [],
      role: template?.role ? template?.role : null,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(2, t("Nome muito pequeno"))
        .max(255, t("Máximo de 255 caracteres permitido para Nome."))
        .required(t("Campo nome é obrigatório.")),
      tag: Yup.string()
        .min(2, t("Tag muito pequena"))
        .max(255, t("Máximo de 255 caracteres permitido para Tag."))
        .required(t("Campo tag é obrigatório.")),
      // checkboxes: Yup.array().min(1, "É necessário escolher ao menos 1 campo."),
      checkBoxesDuallist: Yup.array().min(
        1,
        "É necessário escolher ao menos 1 campo."
      ),
      role: Yup.array()
        .of(
          Yup.object()
            .shape({
              label: Yup.string().required(),
              value: Yup.string().required(),
            })
            .nullable()
        )
        .min(1, "Campo Perfil é obrigatório."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true)
      const { name, tag, isNormalized, checkBoxesDuallist, role } = values
      const roles = role.map(e => e.value).toString()
      try {
        await updateTemplate(
          id,
          name,
          tag,
          checkBoxesDuallist,
          roles,
          isNormalized
        )
        resetForm()
      } catch (error) {
        console.error(error)
        setErrors(error)
      } finally {
        setIsLoading(false)
      }
    },
  })

  const checkboxesOptions = checkboxes?.map(c => ({
    label: c.title,
    value: c.column,
  }))

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <CardBody>
                <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      <NavItem
                        className={classnames({ current: activeTab === 1 })}
                      >
                        <NavLink
                          className={classnames({ current: activeTab === 1 })}
                          disabled
                        >
                          <span className="number">1.</span> Informações
                        </NavLink>
                      </NavItem>
                      <NavItem
                        className={classnames({ current: activeTab === 2 })}
                      >
                        <NavLink
                          className={classnames({ active: activeTab === 2 })}
                          disabled
                        >
                          <span className="number">2.</span> Campos
                        </NavLink>
                      </NavItem>
                      <NavItem
                        className={classnames({ current: activeTab === 3 })}
                      >
                        <NavLink
                          className={classnames({ active: activeTab === 3 })}
                          disabled
                        >
                          <span className="number">3.</span> Confirmação
                        </NavLink>
                      </NavItem>
                    </ul>
                  </div>
                  <div className="content clearfix">
                    <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={1}>
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label className="form-label">{t("Nome")}</Label>
                              <Input
                                name="name"
                                className="form-control"
                                placeholder={t("Nome Completo")}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name &&
                                  validation.errors.name
                                    ? true
                                    : false
                                }
                                autoComplete="off"
                              />
                              {validation.touched.name &&
                              validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label className="form-label">{"Tag"}</Label>
                              <Input
                                name="tag"
                                className="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.tag || ""}
                                invalid={
                                  validation.touched.tag &&
                                  validation.errors.tag
                                    ? true
                                    : false
                                }
                                autoComplete="off"
                              />
                              {validation.touched.tag &&
                              validation.errors.tag ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.tag}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col>
                            <div className="mb-3">
                              <Label className="form-label">{"Perfil"}</Label>
                              <Select
                                classNamePrefix="reactSelect"
                                placeholder="Perfil"
                                name="role"
                                inputId="role"
                                isMulti
                                options={perfisOptions}
                                value={validation.values.role}
                                onBlur={validation.handleBlur}
                                styles={{
                                  menuPortal: base => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                className={
                                  validation.errors.role &&
                                  validation.touched.role
                                    ? "react-select-error"
                                    : ""
                                }
                                onChange={e =>
                                  validation.setFieldValue("role", e)
                                }
                                menuPortalTarget={document.body}
                              />
                              {validation.errors.role &&
                              validation.touched.role ? (
                                <p className="text-red">
                                  {validation.errors.role}
                                </p>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="form-check mb-1">
                              <Input
                                name="isNormalized"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                checked={validation.values.isNormalized}
                                type="checkbox"
                              />
                              <Label className="form-check-label">
                                Campos Normalizados
                              </Label>
                              {validation.touched.isNormalized &&
                              validation.errors.isNormalized ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.isNormalized}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={2}>
                        {/* <Row>
                          <Label className="form-label">{t("Campos")}</Label>
                          <div className="d-flex">
                            {_.chunk(checkboxes, 17).map((columns, i) => {
                              return (
                                <Col key={"checkboxes-column-" + i}>
                                  {columns.map(checkbox => {
                                    return (
                                      <div
                                        key={
                                          "checkboxes-key-" + checkbox.column
                                        }
                                        className="form-check"
                                        style={{ marginBottom: 8 }}
                                      >
                                        <Input
                                          className="form-check-input"
                                          name={"checkboxes"}
                                          id={checkbox.column}
                                          onChange={validation.handleChange}
                                          onBlur={validation.handleBlur}
                                          type="checkbox"
                                          value={checkbox.column}
                                          checked={validation.values.checkboxes.includes(
                                            checkbox.column
                                          )}
                                        />
                                        <Label
                                          className="form-check-label"
                                          htmlFor={checkbox.column}
                                        >
                                          {checkbox.title}
                                        </Label>
                                      </div>
                                    )
                                  })}
                                </Col>
                              )
                            })}
                          </div>
                          {validation.touched.checkboxes &&
                          validation.errors.checkboxes ? (
                            <div type="invalid" style={{ color: "red" }}>
                              {validation.errors.checkboxes}
                            </div>
                          ) : null}
                        </Row> */}
                        <Row>
                          <Col>
                            <Row>
                              {validation.touched.checkBoxesDuallist &&
                              validation.errors.checkBoxesDuallist ? (
                                <div type="invalid" style={{ color: "red" }}>
                                  {validation.errors.checkBoxesDuallist}
                                </div>
                              ) : null}
                            </Row>
                            <Row>
                              <Col>
                                <DualListBox
                                  name="checkboxesDualList"
                                  className="custom-dual-listbox"
                                  options={checkboxesOptions}
                                  canFilter
                                  preserveSelectOrder
                                  showOrderButtons
                                  lang={{
                                    availableFilterPlaceholder:
                                      "Campos Selecionáveis",
                                    selectedFilterPlaceholder:
                                      "Campos Selecionados",
                                    moveAllToAvailable:
                                      "Mover todos para Selecionáveis",
                                    moveAllToSelected:
                                      "Mover todos para Selecionados",
                                    moveToAvailable: "Mover para Selecionável",
                                    moveToSelected: "Mover para Selecionado",
                                    moveBottom: "Mover para Final da Lista",
                                    moveDown: "Mover uma posição para Baixo",
                                    moveUp: "Mover uma posição para Cima",
                                    moveTop: "Mover para Início da Lista",
                                    availableHeader: "",
                                    selectedHeader:
                                      "Ordem dos Campos influencia na ordem das Colunas do Arquivo",
                                  }}
                                  // selected={selectedDualList}
                                  selected={
                                    validation.values.checkBoxesDuallist
                                  }
                                  onBlur={validation.handleBlur}
                                  onChange={values => {
                                    validation.setFieldValue(
                                      "checkBoxesDuallist",
                                      values
                                    )
                                  }}

                                  // onChange={newValue => {
                                  //   validation.setFieldValue(
                                  //     "checkBoxesDuallist",
                                  //     newValue
                                  //   )
                                  //   setSelectedDualList(newValue)
                                  // }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={3}>
                        <Row>
                          {!validation.isValid && (
                            <div className="row justify-content-center">
                              <Col lg="6">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-alpha-x-circle-outline text-danger display-4" />
                                  </div>
                                  <div>
                                    <h5>Erro</h5>
                                    {Object.entries(validation.errors).map(
                                      ([key, value]) => {
                                        return (
                                          <p style={{ color: "red" }} key={key}>
                                            {validation.errors[key]}
                                          </p>
                                        )
                                      }
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </div>
                          )}
                          {isLoading ? (
                            <div
                              className="accordion-body"
                              style={{ textAlign: "center" }}
                            >
                              <Spinner className="ms-2" color="primary" />
                            </div>
                          ) : (
                            validation.isValid && (
                              <div className="row justify-content-center">
                                <Col lg="6">
                                  <div className="text-center">
                                    <div className="mb-4">
                                      <i className="mdi mdi-check-circle-outline text-success display-4" />
                                    </div>
                                    <div>
                                      <h5>Sucesso!</h5>
                                      <Button
                                        onClick={() => {
                                          history.push(
                                            "/rastreio/exportacao/templates"
                                          )
                                          props.setNav(0)
                                        }}
                                      >
                                        Retornar
                                      </Button>
                                    </div>
                                  </div>
                                </Col>
                              </div>
                            )
                          )}
                        </Row>
                      </TabPane>
                    </TabContent>
                  </div>
                  <div className="hstack gap-1 float-end">
                    <Button
                      onClick={() => {
                        toggleTab(activeTab - 1)
                      }}
                      disabled={
                        activeTab === 1 ||
                        (activeTab === 3 && validation.isValid)
                      }
                    >
                      Anterior
                    </Button>
                    <Button
                      onClick={() => {
                        toggleTab(activeTab + 1)
                        if (activeTab === 2) {
                          validation.handleSubmit()
                        }
                      }}
                      disabled={
                        activeTab === 3 ||
                        (activeTab === 3 && validation.isValid)
                      }
                    >
                      Próximo
                    </Button>
                  </div>
                </div>
              </CardBody>
            </Form>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

UpdateTemplate.propTypes = {
  t: PropTypes.any,
  reRenderList: PropTypes.bool,
  setReRenderList: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(UpdateTemplate)
